const KG_DECIMALS = 3;

const normalizeRawInput = (valueOrEvent) => {
  if (typeof valueOrEvent === 'number') {
    return String(valueOrEvent);
  }
  if (typeof valueOrEvent === 'string') {
    return valueOrEvent;
  }
  if (valueOrEvent?.target?.value != null) {
    return String(valueOrEvent.target.value);
  }
  return '';
};

const sanitizeQuantityInput = (valueOrEvent, isKg) => {
  const rawValue = normalizeRawInput(valueOrEvent).replace(',', '.');

  if (!isKg) {
    const cleaned = rawValue.replace(/\D/g, '').replace(/^0+/, '');
    return cleaned || '0';
  }

  const cleaned = rawValue.replace(/[^0-9.]/g, '');
  if (!cleaned) {
    return '0';
  }

  const hasTrailingDot = cleaned.endsWith('.');
  const [integerPartRaw = '0', ...decimalParts] = cleaned.split('.');
  const integerPart = integerPartRaw.replace(/^0+(?=\d)/, '') || '0';
  const decimalPart = decimalParts.join('').slice(0, KG_DECIMALS);

  if (!decimalPart && hasTrailingDot) {
    return `${integerPart}.`;
  }
  if (!decimalPart) {
    return integerPart;
  }
  return `${integerPart}.${decimalPart}`;
};

const applyPadKey = (currentValue, key, isKg) => {
  const baseValue = typeof currentValue === 'string' ? currentValue : String(currentValue || '0');
  let nextValue = baseValue;

  if (key === 'C') {
    nextValue = '0';
  } else if (key === 'BACKSPACE' || key === '<-' || key === '←') {
    nextValue = nextValue.slice(0, -1) || '0';
  } else if (/\d/.test(String(key))) {
    nextValue = nextValue === '0' ? String(key) : `${nextValue}${String(key)}`;
  } else if (key === '.' && isKg && !nextValue.includes('.')) {
    nextValue = nextValue === '0' ? '0.' : `${nextValue}.`;
  }

  return sanitizeQuantityInput(nextValue, isKg);
};

export {
  KG_DECIMALS,
  sanitizeQuantityInput,
  applyPadKey,
};
